// removed by extract-text-webpack-plugin
module.exports = {"sapcnqr-badge":"sapcnqr-badge-926216","sapcnqr-badge--muted":"sapcnqr-badge--muted-75d446"};